import { Spin } from 'antd';
import styled from 'styled-components';

const SpinContainer = styled.div`
    height: ${({ $height }) => $height};
    min-height: ${({ minHeight }) => minHeight};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Spinner = ({ height = '100%', minHeight, children }) => {
    const h = typeof height === 'number' ? `${height}px` : height;

    return (
        <SpinContainer $height={h} minHeight={minHeight}>
            {children || <Spin />}
        </SpinContainer>
    );
};

export default Spinner;
